window.SuppliersInfoGrid = {
  _grid: null,
  _gridApi: null,
  _gridOptions: {
    rowData: null,
    onGridReady(e) {
      return e.api.sizeColumnsToFit();
    },
    onGridSizeChanged(event) {
      return event.api.sizeColumnsToFit();
    },
    headerHeight: 44,
    rowHeight: 44,
    suppressPaginationPanel: true,
    suppressRowClickSelection: true,
    toolPanelSuppressSideButtons: true,
    suppressContextMenu: true,
    stopEditingWhenGridLosesFocus: true,
    rowBuffer: 200,
    domLayout: 'autoHeight',
    defaultColDef: {
      sortable: true,
      resizable: true
    },
    onColumnResized: function (params) { params.api.resetRowHeights() },
    columnDefs: [
      {
        field: 'name',
        headerName: "Name",
        cellClass: 'bold-weight',
        wrapText: true,
        autoHeight: true,
        cellStyle: { 'white-space': 'pre-wrap' },
        cellRenderer(params) {
          if (!params.data) { return; }
          return `<div class='table-company-logo'><img src='${params.data.logo_url}' /></div><a class='company-name' href='/companies/${params.data.slug}'>${params.value}</a>`;
        }
      },
      {
        field: 'status',
        headerName: "Status",
        width: 100,
        cellClass(params) { return params.value; },
        cellRenderer(params) {
          const {
            value
          } = params;
          const title = I18n.t(value || 'pending', { scope: 'product_sets.states' })
          return `<div class='status-label auto label-project-status document-status ${value}'>${title}</div>`;
        }
      },
      {
        field: 'submitted_at',
        headerName: "Submitted On",
        width: 150,
        autoHeight: true
      }
    ],
  },

  initializeView(options, key) {
    if (options == null) { options = {}; }
    const gridDiv = document.getElementById('product-suppliers-info-grid');

    agGrid.LicenseManager.setLicenseKey(key);
    suppressLicenseErrorForTestEnvironment();

    this._gridApi = agGrid.createGrid(gridDiv, this._gridOptions);
    this._gridOptions.api = this._gridApi;
    if (options.data) {
      this._gridApi.setGridOption('rowData', options.data);
    }

    resizeAgGridTable($('#product-suppliers-info-grid')[0], this._gridOptions, 0, 5);
    this._resizeHorizontally();
    $(window).resize(_.bind(this._resizeHorizontally, this));
  },

  _resizeHorizontally() {
    return this._gridApi.sizeColumnsToFit();
  },
}
